import React from 'react';
import {Bar} from 'react-chartjs-2';

export default class SeverityBarChart extends React.Component {

    constructor(props) {
        super(props);

        this.basicDataSet = {
            backgroundColor: [],
            borderWidth: 0,
            minBarLength: 100,
            barPercentage: .9,
            categoryPercentage: .9,
            data: []
        }

        this.basicOptions = {
            maintainAspectRatio: false,
            legend: {
                display: false
            },
            layout: {
                padding: {
                    left: 40,
                    right: 40,
                    top: 160,
                    bottom: 40
                }
            },
            scales: {
                yAxes: [{
                    stacked: true,
                    offset: true,
                    gridLines: {
                        drawBorder: false,
                        color: '#ffffff44',

                    },
                    ticks: {
                        min: 1,
                        // max: 3,
                        stepSize: 1,
                        fontColor: '#ffffffaa',
                        padding: 10,
                    }
                }],
                xAxes: [{
                    stacked: true,
                    offset: true,
                    gridLines: {
                        display: false,
                    },
                    type: 'time',
					time: {
						unit: 'day'
					},
                    ticks: {
                        autoSkip: true,
                        autoSkipPadding: 10,
                        fontColor: '#ffffffaa',
                        padding: 10,
                    }
                }]
            },
            tooltips: {
				enabled: true,
				bodyAlign: 'right',
				rtl: true,
				xPadding: 16,
				yPadding: 16,
				titleMarginBottom: 12,
				bodyMarginBottom: 12,
				bodyFontSize: 16,
				footerFontSize: 14,
				displayColors: true,
                callbacks: {
					title: ( tooltipItem, data ) => {
						// const shortDate = tooltipItem[0].label.slice( 0, tooltipItem[0].label.length - 13 );
						return null; // to present the date change this to: "shortDate"
					},

				},				
			},

        }
    }
    render() {

        const curDataStr = JSON.stringify(this.props.data)

		if(curDataStr !== this.lastDataStr) {
			const {
				country,
				// colors,
				eventsTypes,
				coronaData
			} = this.props.data;
            this.lastDataStr = 	curDataStr;	
            

            const chartData = {
                labels: [],
				datasets: [],
				hebrewLegend: coronaData.hebrew_legend,
				eventsType: eventsTypes
            }

            const countryData = coronaData.data[ country ];
            
            eventsTypes.forEach( (et,i) => {

                const eventsList = countryData[ et ];
                if( eventsList === undefined ) return;

                const dSet = Object.assign( {}, this.basicDataSet );
                dSet.label = coronaData.hebrew_legend[ et ].title;

                const chartNumbers = [];
                const barsColors = [];

                eventsList.forEach( (l,i) => {
                    
                    // if( l.text === undefined ) return;
                    
                    const date = new Date(l.d);
                    chartNumbers.push( {t: date, y: l.v} );

                    barsColors.push( global.getSeverityColor( l.v ).toHexString() );
                    // console.log( l.v );
                });
                
                dSet.data = chartNumbers;
                dSet.backgroundColor = barsColors;

                chartData.datasets.push( dSet );
                
            });

            // chartData.datasets[ 0 ].data = [{t: new Date(), y: 50}, {t: new Date(), y: 50}, {t: new Date(), y: 50}];
            // chartData.labels.push( "אבא", "אמא", "קולה");
// console.log( chartData );
            this.currentChartData = chartData;
        }

        return (
                <Bar
                    data={this.currentChartData}
                    width={100}
                    height={50}
                    options={this.basicOptions}
                />
        );
  }
}